"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/asyncToGenerator"));
var _lodash = _interopRequireDefault(require("lodash"));
var _Logger = _interopRequireDefault(require("@/libs/Logger"));
var _CommonLayout = _interopRequireDefault(require("./CommonLayout"));
var log = _Logger.default.namespace('Startup/kiwiBnc');
var _default = exports.default = {
  components: {
    StartupLayout: _CommonLayout.default
  },
  data: function data() {
    return {
      loading: false,
      username: '',
      password: '',
      statusMessage: ''
    };
  },
  computed: {
    greetingText: function greetingText() {
      var greeting = this.$state.settings.startupOptions.greetingText;
      return typeof greeting === 'string' ? greeting : this.$t('start_greeting');
    },
    buttonText: function buttonText() {
      if (this.loading) {
        return '';
      }
      var greeting = this.$state.settings.startupOptions.buttonText;
      return typeof greeting === 'string' ? greeting : this.$t('start_button');
    }
  },
  methods: {
    startUp: function () {
      var _startUp = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this = this;
        var bncnet, cleanUpEvents, onRegistered, onError, onClose;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.statusMessage = this.$t('logging_in');
              this.loading = true;
              bncnet = this.getBncNetwork();
              cleanUpEvents = function cleanUpEvents() {
                bncnet.ircClient.off('registered', onRegistered);
                bncnet.ircClient.off('irc error', onError);
                bncnet.ircClient.off('close', onClose);
              };
              onRegistered = /*#__PURE__*/function () {
                var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
                  var bncNetworks, i, network, buffers;
                  return _regenerator.default.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        cleanUpEvents();
                        _context.next = 3;
                        return bncnet.ircClient.bnc.getNetworks();
                      case 3:
                        bncNetworks = _context.sent;
                        i = 0;
                      case 5:
                        if (!(i < bncNetworks.length)) {
                          _context.next = 22;
                          break;
                        }
                        network = bncNetworks[i];
                        network.buffers = [];
                        _context.prev = 8;
                        _context.next = 11;
                        return bncnet.ircClient.bnc.getBuffers(network.name);
                      case 11:
                        buffers = _context.sent;
                        network.buffers = buffers;
                        _context.next = 18;
                        break;
                      case 15:
                        _context.prev = 15;
                        _context.t0 = _context["catch"](8);
                        // Log the error here or something
                        log.error(_context.t0);
                      case 18:
                        _this.addNetworkToState(network);
                      case 19:
                        i++;
                        _context.next = 5;
                        break;
                      case 22:
                        _this.monitorNetworkChanges(bncnet, bncNetworks);
                        _this.$refs.layout.close();
                      case 24:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee, null, [[8, 15]]);
                }));
                return function onRegistered() {
                  return _ref.apply(this, arguments);
                };
              }();
              onError = function onError(event) {
                cleanUpEvents();
                _this.statusMessage = _this.$t('invalid_login');
                _this.loading = false;
              };
              onClose = function onClose(event) {
                cleanUpEvents();
                _this.statusMessage = _this.$t('invalid_login');
                _this.loading = false;
              };
              bncnet.ircClient.once('registered', onRegistered);
              bncnet.ircClient.once('irc error', onError);
              bncnet.ircClient.once('close', onClose);
              bncnet.ircClient.connect();
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function startUp() {
        return _startUp.apply(this, arguments);
      }
      return startUp;
    }(),
    getBncNetwork: function getBncNetwork() {
      var bnc = this.$state.setting('bnc');
      if (bnc.network) {
        bnc.username = this.username;
        bnc.password = this.password;
        return bnc.network;
      }
      var options = this.$state.settings.startupOptions;

      // Indicate that all our connections will be going through a BNC
      bnc.active = true;
      bnc.server = options.server || '';
      bnc.port = options.port || 6667;
      bnc.tls = !!options.tls;
      bnc.username = this.username;
      bnc.password = this.password;
      var bncnet = this.$state.addNetwork('bnccontrol', this.username, {
        server: bnc.server,
        port: bnc.port,
        tls: bnc.tls
      });
      bnc.network = bncnet;
      return bncnet;
    },
    addNetworkToState: function addNetworkToState(network) {
      var _this2 = this;
      // Expects network to be in the format of:
      //  {
      //  "buffers":[{"channel":"1","name":"#prawnsalad","joined":"1"}],
      //  "name":"freenode",
      //  "channel":"1",
      //  "connected":"1",
      //  "host":"irc.freenode.net",
      //  "port":"6667",
      //  "tls":"0",
      //  "nick":"notprawn99829"
      //  },
      var net = this.$state.addNetwork(network.name, network.nick, {
        server: network.host,
        port: network.port,
        tls: network.tls,
        password: network.password,
        bncname: network.name,
        username: network.user
      });
      network.buffers.forEach(function (buffer) {
        var newBuffer = _this2.$state.addBuffer(net.id, buffer.name);
        if (buffer.joined) {
          newBuffer.enabled = true;
        }
        if (buffer.seen) {
          newBuffer.last_read = new Date(buffer.seen).getTime();
        }
      });
    },
    monitorNetworkChanges: function monitorNetworkChanges(bncNet, bncNetworks) {
      var _this3 = this;
      var existingNets = Object.create(null);
      function rememberNetworks() {
        this.$state.networks.forEach(function (network) {
          if (!network.connection.bncname) {
            return;
          }
          existingNets[network.connection.bncname] = {
            name: network.connection.bncname,
            host: network.connection.server,
            port: network.connection.port,
            tls: network.connection.tls,
            password: network.password,
            nick: network.nick,
            username: network.username
          };
        });
      }
      rememberNetworks();
      var saveState = function saveState(newVal) {
        _this3.$state.networks.forEach(function (network) {
          // Only deal with BNC networks
          if (network.name === 'bnccontrol') {
            return;
          }
          var bncName = network.connection.bncname;
          var current = existingNets[bncName] || {};
          var tags = {};
          if (network.connection.server !== current.host) {
            tags.host = network.connection.server;
          }
          if (network.connection.port !== current.port) {
            tags.port = network.connection.port;
          }
          if (network.connection.tls !== current.tls) {
            tags.tls = network.connection.tls;
          }
          if (network.password !== current.password) {
            tags.password = network.password;
          }
          if (network.nick !== current.nick) {
            tags.nick = network.nick;
          }
          if (network.username !== current.username) {
            tags.user = network.username;
          }

          // A newly added network would not have a current name property set yet.
          // Only save the network if we've entered a host.
          if (!current.name && tags.host) {
            network.connection.bncname = network.name;
            bncNet.ircClient.bnc.addNetwork(network.name, tags.host, tags.port, tags.tls, tags.nick, tags.user, tags.password);
          } else if (current.name) {
            bncNet.ircClient.bnc.saveNetwork(bncName, tags);
          }
        });
        rememberNetworks();
      };
      var debouncedSaveState = _lodash.default.debounce(saveState, 2000);
      this.$state.$watch('networks', debouncedSaveState, {
        deep: true
      });

      // Just before we connect to a network, make sure the BNC is sabed and connected to
      // it or at least trying to connect.
      this.$state.$on('network.connecting', function (event) {
        saveState();
        var netName = event.network.connection.bncname;
        var networkFromBnc = (0, _find.default)(_lodash.default).call(_lodash.default, bncNetworks, {
          name: netName
        });
        if (networkFromBnc && !networkFromBnc.connected) {
          bncNet.ircClient.raw('BOUNCER connect ' + netName);
        }
      });

      // Very hacky until we have network name renaming on the bnc. When a new network
      // is added, change the name to the next available network name.
      this.$state.$on('network.new', function (event) {
        var currentNum = 1;
        var existingNet = true;
        while (existingNet) {
          existingNet = (0, _find.default)(_lodash.default).call(_lodash.default, _this3.$state.networks, {
            name: 'Network' + currentNum
          });
          if (!existingNet) {
            event.network.name = 'Network' + currentNum;
          }
          currentNum++;
        }
      });
      this.$state.$on('network.removed', function (event) {
        bncNet.ircClient.bnc.removeNetwork(event.network.connection.bncname);
      });
      this.$state.$on('buffer.close', function (event) {
        var buffer = event.buffer;
        var network = event.buffer.getNetwork();
        var bncName = network.connection.bncname;
        if (bncName) {
          bncNet.ircClient.bnc.closeBuffer(bncName, buffer.name);
        }
      });
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["KiwiBnc"]
window._kiwi_exports.components.startups.KiwiBnc = exports.default ? exports.default : exports;
